<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>E-PRIJAVA v postopek certificiranja integrirane pridelave</h1>


      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">

<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            

            

     <div class="display-flex">

    <div>
        <fieldset class="left-border-for-children">
            <div >
            <h6>
            v skladu s Pravilnikom o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023) s sprem. in dop.
            </h6>
            <div> (ustrezno označiti, prijava se oddaja za vsako področje posebej):</div>
            </div>
            <div class="mt-1">
                <div class="vrstica-podrocja"  v-for="p in podrocjacertificiranja" :key="p.id">
                    <input type="checkbox" v-model="prijava.podrocja[p.naziv]"  name="p.naziv" id="p.naziv" class="k-checkbox" />
                    <span>{{ p.dolgo }}</span>
                </div>
                

            </div>

            

            <div style="margin-top:2rem">
            <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h1>1. Podatki o izvajalcu oz. prijavitelju:</h1>
                
            </div>
            <div class="display-row mt-1 display-row-form" >
            <span>Priimek in ime / Naziv:</span>
                <kinput disabled type="text" v-model="prijava.kontakt.naziv"/>
		    </div>

            <div class="display-row mt-1 display-row-form" >
            <span>Naslov izvajalca:</span>
                <kinput disabled type="text" v-model="prijava.kontakt.naslov"/>
		    </div>
            

            <div class="display-row mt-1 display-row-form" >
            <span>Poštna številka:</span>
            <kinput class="ozek" disabled type="text" v-model="prijava.kontakt.postnastevilka"/>
            <span>Pošta:</span>
            <kinput disabled type="text" v-model="prijava.kontakt.posta"/>
		    
		    </div>
            

            <div class="display-row mt-1 display-row-form" >
            <span>Telefon:</span>
                <kinput :disabled="!prijavaodprta" type="text" v-model="prijava.kontakt.telefon"/>
		    </div>
            

            <div class="display-row mt-1 display-row-form" >
            <span>E-pošta:</span>
                <kinput :disabled="!prijavaodprta" type="text" v-model="prijava.kontakt.email"/>
		    </div>

            <div class="display-row mt-1 display-row-form" >
            <span>Spletna stran:</span>
                <kinput :disabled="!prijavaodprta" type="text" v-model="prijava.kontakt.spletnastran"/>
		    </div>

            <div class="display-row mt-1 display-row-form" >
            <span>Spletna trgovina:</span>
                <kinput :disabled="!prijavaodprta" type="text" v-model="prijava.kontakt.spletnatrgovina"/>
		    </div>
            <div class="display-row mt-1 display-row-form" >
            <span>Pravna oblika:</span>
            <dropdownlist class="dropdownfix" :disabled="!prijavaodprta"
                v-model="prijava.pravnaoblika"
                :data-items="pravneoblike"
            >   
        </dropdownlist>
                
		    </div>
            <div class="display-row mt-1 display-row-form" >
            <span>Naslov - lokacija KMG:</span>
                <kinput disabled type="text" v-model="prijava.kontakt.naslovkmg"/>
                <span>Poštna številka:</span>
            <kinput class="ozek" disabled type="text" v-model="prijava.kontakt.postnastevilkakmg"/>
            <span>Pošta:</span>
            <kinput disabled type="text" v-model="prijava.kontakt.postakmg"/>
		    </div>

            <div class="display-row mt-1 display-row-form" >
            <span>KMG-MID</span>
                <kinput disabled type="text" v-model="prijava.kmgmid"/>
                <span>Davčna številka:</span>
            <kinput :disabled="!prijavaodprta" type="text" v-model="prijava.davcnastevilka"/>
            <span>Davčni zavezanec:</span>
            <input type="checkbox" v-model="prijava.davcnizavezanec"  name="davcnizavezanec" id="davcnizavezanec" class="k-checkbox" />
		    </div>
            
            </div>


            <div style="margin-top:2rem">
            <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h1>2. Odgovorna oseba za postopek certificiranja:</h1>
                
            </div>

            <div class="display-row mt-1 display-row-form" >
            <span>Ime odgovorne osebe za postopek :</span>
                <kinput  :disabled="!prijavaodprta"  type="text" v-model="prijava.odgovornaoseba"/>
		    </div>

            <div class="display-row mt-1 display-row-form" >
            <span>Telefon:</span>
                <kinput  :disabled="!prijavaodprta"  type="text" v-model="prijava.telefonoo"/>
		    </div>

            <div class="display-row mt-1 display-row-form" >
            <span>E-pošta:</span>
                <kinput  :disabled="!prijavaodprta"  type="text" v-model="prijava.emailoo"/>
		    </div>

            <div class="mt-1 izjavaokvir">
            <div>Izjavljam, da:</div>
            <ul class="seznam">
                <li>sem seznanjen z zahtevami sheme kakovosti Integrirana pridelava in s Pravili postopka certificiranja (1.80doc – veljavna revizija dostopna na spletni strani www.ikc-um.si);</li>
                <li>dovolim, da IKC UM za namen prijave v postopek certificiranja oz. nadzora preveri oz. uvozi podatke iz uradnih registrov (RKG, AJPES).</li>
</ul>
</div>

            </div>



<!-- obseg certificiranja   -->
<div style="margin-top:2rem">
            <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h1>3. Obseg prijave - kulture</h1>
                
            </div>
            <div class="form-fieldset-header" style="align-items:center;gap:1rem;">
                <div >Pridelovalec mora za prihajajočo sezono za IPP, IPZ, IPG, IPH prijaviti vse površine iz RKG, na katerih poteka oz. bo potekala pridelava poljščin / zelenjave / grozdja / hmelja. Za IPSO mora pridelovalec za prihajajočo sezono prijaviti najmanj eno sadno vrsto in površine iz RKG, na katerih prideluje to sadno vrsto. V postopek certificiranja se ne prijavljajo površine, ki se ekološke ali v postopku preusmeritve v ekološko kmetijstvo. Obseg prijave se dodatno uskladi z dejanskim stanjem ob redni kontroli.</div>
            </div>
            
            <div class="form-fieldset-header" style="align-items:center;gap:1rem;">
                <div >Kulture (za dodajanje kultur vnesite prve tri črke kulture iz šifranta):</div>
            </div>
            


			<template v-for="(podshema,i) in podrocjacertificiranja">
			<div class="display-flex" style="align-items:center;gap:1rem;">  
				<span>{{ podshema.prikaz }}</span>
				<div class="k-form-field display-flex flex-grow-1">
            	<kendo-multiselect :disabled="!prijava.podrocja[podshema.naziv]" :value="prijava.obseg[podshema.naziv]"
                        :data-items="ipobsegcertificiranjafilter[podshema.naziv]"
                        :text-field="'naziv'"
                        :data-item-key="'šifra'"
                        :placeholder="'Izberi'"
                        :id="'obseg'+podshema.naziv"
                        @change="spremeniobseg($event,podshema.naziv)"
                        :messages="multiselectmessages"
                        :filterable="true"
						@filterchange="onFilterChange($event,podshema.naziv)"
                        :style="{ width: '400px'}"
                        >
            	</kendo-multiselect>
				</div>
			</div>
		</template>
 
</div>

<div class="mt-2 izjavaokvir">
            <div>Izvajalec ali pooblaščenec odda prijavo:</div>
            <ul class="seznam">
                <li>elektronsko (s klikom na polje oddaj vlogo) ALI</li>
                <li>prijavni obrazec natisne, ga lastnoročno podpiše in posreduje na IKC UM (scan prijave na e-pošto info@ikc-um.si ali z redno pošto na IKC UM, Pivola 8, SI-2311, Hoče)</li>
</ul>
<div class="oddajavloge">
        <div><div style="flex: 1 1 100%;">DATUM</div></div>
        <div class="divider"></div>
        <div><div style="flex: 1 1 100%;">Ime in priimek izvajalca / pooblaščene osebe</div></div>
        <div class="divider"></div>
        <div><div style="flex: 1 1 100%;" class="no-show"><div>Podpis odgovorne osebe</div><div>žig (v kolikor ga uporabljate)</div></div></div>
</div>
<div class="oddajavloge">
<div><div style="flex: 1 1 100%;">{{ prijava.datumoddajeizpis }}</div></div>
<div class="divider"></div>
<div><div style="flex: 1 1 100%;" ><div>{{ prijava.odgovornaoseba }}</div></div></div>
<div class="divider"></div>
<div><div style="flex: 1 1 100%;">    <button class="k-button k-primary no-print" :disabled="!prijavaodprta" @click="saveData" >Oddaj vlogo</button></div></div>
</div>

</div>

</fieldset>

<div style="margin-top:2rem">
   <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
        <h1>Priloga 1: Obseg površin vključenih v postopek certificiranja</h1>
    </div>
       <table class="mt-2" id="gerki">
         <colgroup>
        <col style="width:10%">
        <col style="width:10%">
        <col style="width:auto">
        <col style="width:20%">
        <col style="width:10%">
        <col style="width:5%">
       
    
        
  </colgroup> 
        <thead>
        <tr>
            <th>Zap. št.</th>
            <th>GERK_PID</th>
            <th class="raba">Opis</th>
            <th>Domače ime</th>
            <th>Pov (a)</th>
            <template  v-for="p in podrocjacertificiranja">
            <th v-if="prijava.podrocja[p.naziv]">
                    <span>{{ p.dolgo }}</span>
            </th>
            </template>
			
			
            
            

        </tr>
    </thead>
  <tr v-for="gerk in prijava.gerki" :key="gerk.gerkpid">
    <td>{{ gerk.st}}</td>
    <td>{{ gerk.gerkpid}}</td>
    <td>{{ gerk.raba}}</td>
    <td>{{ gerk.domaceime}}</td>
    <td>{{ gerk.povrsina.toFixed(0)}}</td>
	
    <template  v-for="p in podrocjacertificiranja">
        <td v-if="prijava.podrocja[p.naziv]">
                    <input type="checkbox" :checked="preveriBool(gerk,p.naziv)" @change="zamenjaj(gerk,p.naziv,$event)"  :name="p.naziv+gerk.st" :id="p.naziv+gerk.st" class="k-checkbox" />
                    
            </td>
    </template>
			
   
	
    
  </tr>
  <tr class="vsota"><td colspan="2">Obseg površin (a):</td><td colspan="3">{{gerki.reduce((a,i)=>{return a+i.povrsina;},0).toFixed()}}</td></tr>
</table>
               
          
</div>

</div>       
                
             </div>
        </form>
    </div>
    </div>
    </div>
    </div>

</template>
<style >

 @media  print {
    @page {

margin-top: 10mm;
margin-bottom: 10mm;
margin-left: 10mm;
margin-right: 10mm;
size: A4 portrait;

}
.glava_vsebine.adapt.v-adapt{
    margin-top: 0;
    
}
.glava_vsebine h1,.glava_vsebine h6,.glava_vsebine sub{
    color: var(--accent);
    margin-bottom: 0;
}
#wrapper{
    padding-top: 0px;
}

.no-show{

    visibility: visible !important;
}
header,.navigation,.menus,.menu{
    display:none;
    visibility:hidden;
}
.no-print{
    visibility:hidden;
}
    }
.no-show{
    visibility: hidden;
}
.vrstica-podrocja {
    display: flex;
    gap:10px;
    font-size:1.5em;
    align-items: center;
}
.dropdownfix{
flex: 1 1 auto !important;
}
.k-multiselect, .k-dropdownlist {
    flex-grow: 1 !important;
}
table#gerki,.povrsine table#gerki th, table#gerki td {
    border:1px solid black;
    border-collapse:collapse;

}
table#gerki td,  table#gerki th {
    padding:0 1mm;
    white-space: nowrap;
    width:1px;

}
 table#gerki .vsota, .dodatni-podatki table .vsota {
    font-weight:bold;
}

.oddajavloge{
    display:flex;
    align-items: stretch;
    border-top: 1px solid var(--accent);

}
.oddajavloge>.divider{
    border-left:1px solid var(--accent);
    flex:1 1 1px;
}
.oddajavloge>div{
    flex:1 1 33%;
    text-align: center;
    display: flex;
    align-items: center;
   
    

}
.form-fieldset-header h1 {
    font-size: 1.3em;

}
.izbranakategorija{
   background-color: var(--accent);
   
}
.k-checkbox-field {
    display: flex !important;
    align-items: center;
}
.kat_chk_list{
display:flex;
flex-direction:column;

}

form {
display:flex;
flex-direction:column;
}

.k-checkbox-field input[type="checkbox"]{
    margin-left: 0.5rem;

}

.mt-1 {
	margin-top: 1rem !important;
	}

    .mt-2 {
	margin-top: 2rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:5px;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 20%;
	}
    .display-row-form>span{
    flex: 0 0 auto;
    }
    .display-row-form> span.k-input{
		flex:1 1 auto;
	}
    .display-row-form  .ozek{
		flex:1 1 10% !important;
	}

    .izjavaokvir {
        border: 1px solid var(--accent);
        
    }
    .seznam{
        padding-left:15px
    }
    ul.seznam > li:before {
  content: "-";
  margin-right: 10px;
  
}
</style>
<script>
import Vue from 'vue';
import moment from 'moment';
import { mapState, mapActions,mapMutations } from 'vuex';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import { Input } from '@progress/kendo-vue-inputs';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';

import PridelovalecKratko from './support/PridelovalecKratko';
import { pridelavaService } from '../services/pridelava.service';
import { authHeader } from '../helpers';
import { Upload } from '@progress/kendo-vue-upload';
import { tableKeyboardNavigationHeaderAttributes } from '@progress/kendo-vue-data-tools';
import { prijavaService } from '../services/prijava.service';
import {store} from '../store/index.js'
export default {
     components: {
        'kinput': Input,
	'kbutton': Button,
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'pridelovalec':PridelovalecKratko,
    'kendo-checkbox': Checkbox,
    'Grid': Grid,
     'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
	  upload: Upload,
  },
    props:['sezona','pridelovalecid','shema'],
    data () {
        return {
            prijavaodprta:true,
            opozorilo:"",
            datumzadnjeoddaje:null,
			      dataSezona:this.sezona,
                   sezone:[],
                
            pravneoblike:["Fizična oseba","s.p.","d.o.o.","z.o.o.","z.b.o.","d.d.","d.n.o.","zavod"],
            prijava:{},
            kontakt:{},
            ip:{
                individualno:true,
                skupnsko:false,
                status:{naziv:"aktiven",id:1},
                izbrandatumdolocitvestatusa:null,
                izbranosteviloclanov:0,
                izbrandatumdolocitvestevilaclanov:null,
                podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2}],
                osebe:[{}],
                podizvajalci:[{}],
				prijava:{datumpopolnosti:null,datumpregleda:null,datumprijave:null}

            },
            gerki:[],
            nacinprijaveip:[{naziv:"Pošta",id:0},{naziv:"E-pošta",id:1},{naziv:"Osebno",id:2},{naziv:"E-prijava",id:3}],
			vrstaprijaveip:[{naziv:"Prva prijava",id:0},{naziv:"Obnova prijave",id:1},{naziv:"Obnova prijave zaradi sprememb",id:2}],
			podrocjacertificiranja:[{"naziv":"IPS","id":1, "prikaz":"IPSO",dolgo:"SADJE IN OLJKE (IPSO)"},{"naziv":"IPG","id":2, "prikaz":"IPG",dolgo:"GROZDJE (IPG)"},
            {"naziv":"IPP","id":3, "prikaz":"IPP",dolgo:"POJLŠČINE(IPP)"},{"naziv":"IPZ","id":4, "prikaz":"IPZ",dolgo:"ZELENJAVA (IPZ)"},{"naziv":"IPH","id":5, "prikaz":"IPH",dolgo:"HMELJ (IPH)"}],
            ipobsegcertificiranja:[],
			ipobsegcertificiranjafilter:{},
            kmgmid:"",posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",emso:"",imekontakt:"",kntst:"",
            emailnosilca:"",telefonnosilca:"",
           files:[],
            iscipodizvajalca:'',
            iscipodizvajalcaerror:'',
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrstapridelave:["EK+K","EK-P","P"],
            
            vrsta:[],
            status:[],
            statuskategorije:[],
            kategorije:[]
        }
    },
    computed: {
		
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        obsegcertificiranja:
        {
           get() {

           
                return this.prijava.obseg;
            

          }
        },
        
    },
    created () {
      if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};
    
      if(!this.shema)
        this.shema="IP";
	    this.naloziPodatke(this.shema,this.sezona,this.pridelovalecid);
      // this.naloziPodatke();
     
    },
	beforeRouteUpdate (to, from,next) {
    	this.naloziPodatke(to.params.shema,to.params.sezona,to.params.pridelovalecid,next);
	},
    methods: {
        
         zamenjaj(gerk,naziv,event){
            console.log(JSON.stringify(gerk));
            let checked=event.target.checked;
            console.log(gerk.kontrolaIP);
            if(!gerk.kontrolaIP)
                gerk.kontrolaIP={};
            gerk.kontrolaIP[naziv]=checked;

            console.log(gerk);

         },
         preveriBool(gerk,naziv){
            
            if(!gerk.kontrolaIP)
                return false;
            else {
              
                return gerk.kontrolaIP[naziv];
            }



         },
         boolcheck(boolobject){
			if(!boolobject)
				return false
			else 
				return true
		},
		authorize(event) {
			event.headers=authHeader();
		},
	
		spremeniobseg (event,podshema)  {
			//let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema==this.shema);
            Vue.set(this.prijava.obseg,podshema,[...event.target.value])
			//console.log(this.ip.prijava.obseg);
        },
       

        saveData(e){
        
            prijavaService.saveOne(this.prijava,this.sezona,this.pridelovalecid,"IP",'prijavaip_2023').then(
			prijavadata=>{
                store.dispatch('alert/success', "Vloga je bila uspešno oddana. O tem boste obveščeni tudi preko elektronske pošte!", { root: true });
            },
            err=>{
                store.dispatch('alert/error', "Napaka pri oddaji vloge!", { root: true });
            }
            );
           
        
        },
          handleSubmit(e){

          e.preventDefault();
        },
        cancel(e){
			this.$router.push({ name: 'sheme', params: { sezona:sezona.sezona,shema:this.shema},query:{shema:this.shema,sezona:this.sezona} })
        },
       
		naloziPodatke (shema,sezona,pridelovalecid,next){
        //treba še it po podakte o vrstah podshem
        
        var thisComp=this;
        
            prijavaService.loadOne(sezona,pridelovalecid,shema,'prijavaip_2023').then(
			prijavadata=>{
                let p=prijavadata.pridelovalec;
                thisComp.pridelovalec=p;

                thisComp.ipobsegcertificiranja=prijavadata.sifrant["ipobsegcertificiranja"];
		    	
                for (let podshema of thisComp.podrocjacertificiranja)
				    Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
		

                if(prijavadata.prijava){
                    thisComp.prijava=prijavadata.prijava;
                    thisComp.datumzadnjeoddaje=prijavadata.createdAt;
                }
                else
                    thisComp.prijava={};

            let pridelava=p.sheme.find(s=>s.sezona==sezona&&s.shema==shema)?.ip;
            console.log("našel podatke");
            console.log(JSON.stringify(pridelava.podrocjacertificiranja));
            //gerki
            if(!thisComp.prijava.gerki) {

                thisComp.gerki=prijavadata.gerki
					.sort((a,b)=>{
                			if (a.blokid>b.blokid)
                    			return 1;
                			else if(a.blokid==b.blokid)
                    			return a.gerkpid>b.gerkpid?1:-1
                			else
                    			return -1;
                    }).map((e,i)=>{return {...{st:i+1},...e}});
					thisComp.prijava.gerki=thisComp.gerki;

            }
                
                
                

            let kontakt=p?.kontakt?.find(k=>k.vloga=='nosilec kmg');
            let kontaktkmg=p?.kontakt?.find(k=>k.vloga=='kmetija (kmg)');
            if(!kontakt)
                kontakt=thisComp.pridelovalec?.kontakt[0];
                thisComp.kontakt=kontakt;
            let odgovornaoseba=pridelava.osebe[0];
            
            if(!thisComp.prijava.kontakt)
            thisComp.prijava.kontakt=kontakt;
           
            if(!thisComp.prijava.kontakt.naziv)
            thisComp.prijava.kontakt.naziv=kontakt?.naziv;
            if(!thisComp.prijava.kontakt.naslov)
            thisComp.prijava.kontakt.naslov=kontakt?.naslov;
            if(!thisComp.prijava.kontakt.posta)
            thisComp.prijava.kontakt.posta=kontakt?.posta;
            if(!thisComp.prijava.kontakt.postnastevilka)
            thisComp.prijava.kontakt.postnastevilka=kontakt?.postnastevilka;
           
            if(!thisComp.prijava.kontakt.naslovkmg)
            thisComp.prijava.kontakt.naslovkmg=(kontaktkmg?.naslov)?kontaktkmg.naslov:kontakt?.naslov;
            if(!thisComp.prijava.kontakt.postakmg)
            thisComp.prijava.kontakt.postakmg=(kontaktkmg?.posta)?kontaktkmg.posta:kontakt?.posta;
            if(!thisComp.prijava.kontakt.postnastevilkakmg)
            thisComp.prijava.kontakt.postnastevilkakmg=(kontaktkmg?.postnastevilka)?kontaktkmg.postnastevilka:kontakt?.postnastevilka;;


            if(!thisComp.prijava.kontakt.telefon)
            thisComp.prijava.kontakt.telefon=kontakt?.telefon;
            if(!thisComp.prijava.kontakt.email)
            thisComp.prijava.kontakt.email=kontakt?.email;
            if(!thisComp.prijava.kontakt.spletnastran)
            thisComp.prijava.kontakt.spletnastran=kontakt?.spletnastran
            if(!thisComp.prijava.kontakt.spletnatrgovina)
            thisComp.prijava.kontakt.spletnatrgovina=kontakt?.spletnatrgovina
            
            
            
            if(!thisComp.prijava.kmgmid)
            thisComp.prijava.kmgmid=p?.kmgmid;
            
              if(!thisComp.prijava.davcnastevilka)
              thisComp.prijava.davcnastevilka=p?.davcnastevilka;
    
            if(!thisComp.prijava.davcnizavezanec)
            thisComp.prijava.davcnizavezanec=pridelava?.davcnizavezanec;
            if(!thisComp.prijava.pravnaoblika)
            thisComp.prijava.pravnaoblika="Fizična oseba";
            
              if(!thisComp.prijava.odgovornaoseba)
              thisComp.prijava.odgovornaoseba=odgovornaoseba?.naziv;
              if(!thisComp.prijava.telefonoo)
              thisComp.prijava.telefonoo=odgovornaoseba?.telefon;
              if(!thisComp.prijava.epostaoo)
              thisComp.prijava.emailoo=odgovornaoseba?.email;
    
              if(!thisComp.prijava.podrocja){
                Vue.set(thisComp.prijava,"podrocja",
                pridelava.podrocjacertificiranja.reduce( (a,c)=>{
                    if(c.status?.id==1)
                      Vue.set(a,c.naziv,true);
                    else
                        Vue.set(a,c.naziv,false);
                    return a;
                },{})
                )
            }
              console.log(thisComp.prijava.podrocja);
            
            if(!thisComp.prijava.datumoddaje){

                thisComp.prijava.datumoddaje=new Date();
            }
            else
            thisComp.opozorilo="Vlogo ste že oddali";
            
            thisComp.prijava.datumoddajeizpis=moment(this.prijava.datumoddaje).format("DD.MM.YYYY");

            //naloži prijavo od lani...
            

            if(!thisComp?.prijava?.obseg||Array.isArray(thisComp?.prijava?.obseg))
                    if(!pridelava?.prijava?.obseg||Array.isArray(pridelava?.prijava?.obseg)){
				        Vue.set(thisComp.prijava,'obseg',{});
                        console.log("nastavil sem obseg")
                        console.log(thisComp.prijava.obseg);
                    }
                    else
                    Vue.set(thisComp.prijava,"obseg",pridelava?.prijava?.obseg);
			
			
            
            if(next)
                next();
            },
            err=>{
                store.dispatch('alert/error', "Pri nalaganju obstoječe prijave je prišlo do težave!", { root: true });
            }
            )
        
        
      
        },
		onFilterChange(event,podshema) {
			
            
			Vue.set(this.ipobsegcertificiranjafilter,podshema,filterBy(this.ipobsegcertificiranja.filter(i=>i.področje==podshema).slice(), event.filter))
			
        },
         sezonaChange(event) {
         
            const sezona = event.value;
            this.dataSezona=sezona;
            this.$router.push({ name: 'ipprijava', params: { sezona:sezona.sezona,shema:this.shema,pridelovalecid:this.pridelovalecid} })
            /*
            this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'pridelovalec', params: {sezona:sezona.sezona,pridelovalecid:pridelovalec.id} });
             this.naloziPodatke();
              });

*/
          //  this.naloziPodatke();



        },
    }
};
</script>

